import React, { useEffect, useState } from "react"
import {  useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Search from 'pages/parts/Search'
import Pagination from 'pages/parts/Pagination'

import { PGET } from 'helpers/api'
import { formatDate, formatMoney, regexPhoneNumber } from "helpers/helpers"


function Index() {
	const { t } = useTranslation()
	const { id } = useParams()

	const URL = `/services/web/api/company-cars/${id}`

	const settings = useSelector(state => state.settings)
	const [pageCount, setPageCount] = useState(0)
	const [data, setData] = useState([])

	async function getData() {
		const response = await PGET(`/services/web/api/company-cars/${id}`, {}, { loader: true })
		if (response) {
			setPageCount(Math.ceil(response.headers['x-total-count'] / settings.size))
			setData(response.data)
		}
	}

	async function paginate(data) {
		const response = await PGET(`/services/web/api/company-cars/${id}`, { page: data.selected, size: settings.size }, { loader: true })
		setData(response.data);
	}

	async function search(data, searchValue) {
		setData(data);
		if (searchValue.length > 0) {
			setPageCount(0)
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('COMPANY')} / {t('CARS')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3">
						<div className="me-2">
							<Search url={URL} search={search} getData={getData}></Search>
						</div>
					</div>
					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th>{t('USER')}</th>
									<th>{t('PHONE')}</th>
									<th className="text-center">{t('CAR_TYPE')}</th>
									<th className="text-center">{t('CAR_NUMBER')}</th>
									<th className="text-center">{t('BALANCE')}</th>
									<th className="text-center">{t('MONTH_LIMIT')}</th>
									<th className="text-center">{t('BALANCE_LIMIT')}</th>
									<th className="text-center">{t('LAST_CHEQUE_DATE')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td>{item.userName}</td>
										<td>{regexPhoneNumber(item.userPhone)}</td>
										<td className="text-center">{item.carTypeName}</td>
										<td className="text-center">{item.carNumber}</td>
										<td className="text-center">{item.balance}</td>
										<td className="text-center">{formatMoney(item.monthLimit)}</td>
										<td className="text-center">{formatMoney(item.balanceLimit)}</td>
										<td className="text-center">{formatDate(item.lastChequeDate)}</td>
									</tr>
								))
								}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
				</div>
			</div>
		</>
	)
}

export default Index
